<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';

  let name = '';
  let description = '';
  let startDate = '';
  let endDate = '';

  let error = '';
  let isSubmitting = false;
  let currentUser = null;

  onMount(() => {
    const unsubscribe = authStore.subscribe(value => {
      currentUser = value.user;
    });
    return unsubscribe;
  });

  async function handleSubmit() {
    isSubmitting = true;
    error = '';

    if (!name || !startDate || !endDate || !description) {
      error = 'All fields are required.';
      isSubmitting = false;
      return;
    }

    const payload = {
      name,
      description,
      start_date: new Date(startDate).toISOString(),
      end_date: new Date(endDate).toISOString(),
      createdByUserId: currentUser?.idTokenClaims?.oid,
    };

    try {
      const response = await fetch(getApiUrl('/promotions/simplified'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || 'Failed to add promotion.');
      }
      
      // Redirect to the user's list of promotions to see the new one
      navigate(`/promotions/user/${currentUser?.idTokenClaims?.oid}`);

    } catch (e) {
      error = e.message;
    } finally {
      isSubmitting = false;
    }
  }
</script>

<div class="form-container">
  <h2>Add a Simplified In-Store Promotion</h2>
  <p>This form will create a new promotion that is automatically set to "In-Store" and will include all of your claimed premises.</p>
  <form on:submit|preventDefault={handleSubmit}>
    <fieldset>
      <div class="form-group">
        <label for="name">Promotion Name</label>
        <input type="text" id="name" bind:value={name} />
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" rows="4" bind:value={description}></textarea>
      </div>
      <div class="form-group">
        <label for="start-date">Start Date</label>
        <input type="datetime-local" id="start-date" bind:value={startDate} />
      </div>
      <div class="form-group">
        <label for="end-date">End Date</label>
        <input type="datetime-local" id="end-date" bind:value={endDate} />
      </div>
    </fieldset>

    <button type="submit" disabled={isSubmitting}>
      {#if isSubmitting}Creating...{:else}Create Promotion{/if}
    </button>
    {#if error}
      <p class="error">{error}</p>
    {/if}
  </form>
</div>

<style>
  .form-container { 
    max-width: 700px; 
    margin: 2rem auto; 
    background: #fff;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  }
  form { display: flex; flex-direction: column; gap: 1rem; }
  fieldset { border: none; padding: 0; margin: 0; }
  .form-group { margin-bottom: 1rem; }
  label { display: block; margin-bottom: 0.5rem; font-weight: 500; }
  input, textarea { 
    width: 100%; 
    padding: 0.75rem; 
    border: 1px solid #ccc; 
    border-radius: 4px; 
    font-size: 1rem; 
    box-sizing: border-box; 
    font-family: inherit;
  }
  button { 
    padding: 0.75rem; 
    background-color: #28a745; 
    color: white; 
    border: none; 
    border-radius: 4px; 
    font-size: 1.1rem; 
    cursor: pointer; 
    margin-top: 1rem; 
  }
  button:disabled { background-color: #aaa; }
  .error { color: red; text-align: center; }
</style>
